export default {
  paged: {
    select: 'id,created,year,month,source,provider,family,totalTokens,finalPrice',
    searchSelect: ['family'],
    expand: {
      model: {
        select: 'name',
      },
      processInstance: {
        select: 'name',
      },
      chatThread: {
        select: 'number',
      },
    },
  },
  itemDetail: {
    select:
      'id,year,month,source,provider,family,inputTokens,inputTokensCache,outputTokens,totalTokens,finalPrice,created',
    expand: {
      model: {
        select: 'name',
      },
      process: {
        select: 'name',
      },
      processInstance: {
        select: 'id,name',
      },
      actionInstance: {
        select: 'config,status',
      },
      chatThread: {
        select: 'number',
      },
      connection: {
        select: 'name',
      },
      user: {
        select: 'fullName',
      },
      app: {
        select: 'name',
      },
    },
  },
};
